import Box, { BoxProps } from "@mui/material/Box";
import { PropsWithChildren } from "react";

type FlexBoxProps = PropsWithChildren<{
    orientation?: "row" | "column";
}> & Omit<BoxProps, "display" | "flexDirection">;

export default function FlexBox({ children, orientation = "column", ...boxProps }: FlexBoxProps) {
    return <Box display="flex" flexDirection={orientation} width="100%" {...boxProps}>{children}</Box>;
}